import type { FC, HTMLProps } from 'react';
import clsx from 'clsx';
import { useLocale } from 'hooks';
import { useFormContext } from 'react-hook-form';

interface IProps extends HTMLProps<HTMLInputElement> {
    label: string;
    name: string;
}

const TextFieldComponent: FC<IProps> = ({
    label,
    placeholder,
    name
}) => {
    const { register } = useFormContext()
    const { isRTL } = useLocale()
    return <div>
        <label className="tw-text-sm xxxl:tw-text-[17.33px] tw-font-medium tw-text-[#344456]">
            {label}
        </label>
        <input
            className={clsx(
                "tw-rounded-[8px] xxxl:tw-rounded-[10.67px] tw-px-4 tw-py-3.5 tw-border tw-border-[rgba(52,68,86,0.2)]/30 focus-visible:!tw-border focus-visible:!tw-border-solid focus-visible:!tw-border-[rgba(52,68,86,0.2)]/50 tw-w-full tw-mt-2.5 xxxl:tw-mt-[13.3px] placeholder:tw-text-[rgba(52,68,86,0.3)] tw-bg-zero xxxl:tw-text-[17.33px]",
                { ltr: !isRTL }
            )}
            placeholder={placeholder}
            {...register(name)}
        />
    </div>
}

export default TextFieldComponent;